import React, { Component } from 'react'

import Menu from './Menu'
import Post from './Post'
import SliderBrand from './SliderBrand'
import PostRelContent from './Postrel'
import RedSocial from './redsocial'
import Contact from './contact'

import { connect } from 'react-redux'
import { initLocation,
  initCategories, 
  initPostAsync, 
  initMenuAsync, 
  order, 
  filter, 
  PostSlugAsync, 
  PostnotSlugAsync, 
  PostCategoryAsync,
  initPostClear,
  PostCategoryCountryAsync,
  PostnotSlugAsyncbyCountry
} from './actions'

//import { DFPSlotsProvider, AdSlot } from 'react-dfp';

class Detailpost extends Component {
  constructor(props){
    super(props)
    this.state = {
      postObj:[],
      relObj:[],
      menu:[],
      article:[],
      loading: true,
      item:0,
      imgback: '',
      name: '',
      catName:'',
      relObjfill:[],
      objRel: [],
      columnObj:[],
      idCat:'',
      url:'',
      idAds:0,
      runFun: true,
      menuSel:'',
      countryId:0,
      selectBrand: [],
      propsRelObj:[],
      RelObj:[],
      tagidLoc:0
    }
  }

  componentDidMount(){
    this.props.getLocation()
    this.props.getMenuInit()

    this.setState({ 
      url: `/${this.props.match.params.yearPath}/${this.props.match.params.monthPath}/${this.props.match.params.dayPath}/`
    })

    //this.props.getPostSlug(this.props.match.params.postPath)
    this.props.getPostNotSlug(this.props.match.params.postPath)
  }

  componentWillReceiveProps(next_props) {
    if(next_props.country.location !== this.state.country){
      let nameMenu = `menu-${next_props.country.idtag.slug}`
      let idCo = next_props.country.idtag.term_id
      this.setState({
        country: next_props.country.location,
        menuSel: nameMenu,
        tagidLoc: next_props.country.idtag.term_id,
        defaultCountry: idCo,
        selectDest: [],
        selectBrand: [],
        selectCase: []
      })
      this.props.clearPost()
      
      this.props.getCategorybyCountry(12, next_props.country.idtag.term_id)
      this.props.getPostNotSlugbyCountry(this.props.match.params.postPath, next_props.country.idtag.term_id)
    }

    if(next_props.postObj !== this.state.postObj){
      next_props.category.slice(0).map((item, i) =>{
        this.setState({
          idCat: item.id,
          catName: item.name
        })
        return true;
      })

      let lectordata = next_props.postObj.filter((itemdata) => {
        for (var i = itemdata.categories.length - 1; i >= 0; i--) {
          return itemdata.categories[i] === 3
        }
        return false;
      })

      this.setState({
        article: lectordata
      });

      let columnPost = next_props.postObj.filter(this.dataFilterColumns)

      columnPost = columnPost.sort(function(a, b){return b.id-a.id})

      let dat1=this.state.columnObj.length
      let dat2=columnPost.length

      if(dat1 < dat2){
        this.setState({
          columnObj: columnPost
        });
      }

      let post = next_props.postObj.filter((itemdata) => {
        return itemdata.slug === this.props.match.params.postPath
      })

      post.map((item, i) => {
        item.categories.map((cat, c) => {
          next_props.postObj.filter((itemdata) => {
            for (var i = itemdata.categories.length - 1; i >= 0; i--) {
              return itemdata.categories[i] === cat
            }
            return true
          })
          return true
        })
        return true
      })

      this.setState({
        postObj: post
      });


      this.state.postObj.map((item, i) => {
        return this.setState({
          relObj: item.tags,
          nameact: item.title.rendered,
        })
      })

      let branddata = next_props.post.filter((itemdata) => {
        return itemdata.categories.indexOf(12) !== -1
      })

      branddata = branddata.sort(function(a, b){return b.id-a.id})
      
      this.setState({
        selectBrand: branddata
      });

      let postrel = next_props.post.filter((itemdata) => {
        return itemdata.categories.indexOf(25) !== -1
      })
      
      postrel = postrel.slice(0,3)
      this.setState({
        propsRelObj: postrel
      })


      if(next_props.postRel !== this.state.RelObj){
        let relObj = next_props.postRel.filter((itemdata) => {
          return itemdata.tags.indexOf(this.state.tagidLoc) !== -1
        })
        relObj = relObj.slice(0,3)
        this.setState({
          RelObj: relObj
        })
      }

      if(next_props.postRel !== this.state.propsRelObj){
        let reldata = next_props.postRel.sort(function(a, b){return b.id-a.id})
        reldata = reldata.slice(0,3)
        this.setState({
          propsRelObj: reldata
        })
      }

    }
    
  }


  dataFilterColumns(value, index){
     for (var i = value.categories.length - 1; i >= 0; i--) {
      if(value.categories[i] === 12){
        return true;
      }
    }
    return false;
  }


  render() {
    return (
      <div className="cont_detail">
        <header className="App-header">
          <div className="">
            <div className="row">
              <div className="col s12 m11 offset-m1 l7 offset-l5 logo">
                <Contact search={false}/>
                <RedSocial search={true}/>
                <Menu slug='locations' select={true}col={12} scrollMenu={false} changeGeo={true} defCountry={this.state.defaultCountry}/>
              </div>
              <div className="col s12 m12 l12 nav_principal">
                <Menu slug={this.state.menuSel}  col={12} scrollMenu={true}/>
              </div>
            </div>
          </div>
        </header>
        <section>
          <div className="col s12 ">
            <div className="container">
              <div className="row">
                <div className="col s12 m12 l12">
                   {
                    this.state.catName !== '' && this.state.catName !== 'Canales' && 
                    <Post content={this.state.postObj} title_cat={this.state.catName} classColor="bg_color_new_s" geoCity={this.state.country} reldatapost={(this.state.propsRelObj)?this.state.propsRelObj :[] }/>
                  }
                  {
                    this.state.catName !== '' &&  this.state.catName === 'Canales' && 
                    <Post content={this.state.postObj} title_cat="Audiencia" classColor="bg_color_new_s" nameFile="Parrila de programacion" relObj={this.state.RelObj} geoCity={this.state.country}/>
                  }
                </div>
              </div>
            </div>
          </div>
          { 
            this.state.propsRelObj && this.state.catName !== 'Actualidad del mercado' &&
            <div className="col s12 bg_case bgrelpost">
              <div className="container">
                <PostRelContent post={(this.state.propsRelObj)?this.state.propsRelObj :[] } />
              </div>
            </div>
          }
        </section>
        <footer>
          <div className="line_bg"></div>
          <div className="cont_slider_brand">
            <div className="container">
              <div className="row">
                <div className="col s1"></div>
                <div className="col s10">
                   <SliderBrand content={this.state.selectBrand}/>
                </div>
                <div className="col s1"></div>
              </div>
            </div>
          </div>
          <div className="cont_log_footer">
            <div className="container">
              <div className="row">
                <div className="col s12 m7 text_vc">
                  <p>COPYRIGHT @ VC MEDIOS S.A. 2018 > TODOS LOS DERECHOS RESERVADOS</p>
                  <p><a href="/terminos-y-condiciones-politica-de-privacidad/">TERMINOS Y CONDICIONES</a> | <a href="/terminos-y-condiciones-politica-de-privacidad/">POLITICAS DE PRIVACIDAD</a></p>
                </div>
                <div className="col s12 m5 brand_vc">
                  <img className="col s6" src="/assets/images/logo_vc_footer_b.png" alt=""/>
                  <img className="col s6" src="/assets/images/logo_vcDigital_footer_b.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}


function mapStateToProps (reducer){
  return {
    pageTotal: reducer.page,
    postObj: reducer.post,
    menus: reducer.menus,
    category: reducer.categories,
    postRel: reducer.postrel,
    country: reducer.country,
    post: reducer.post,
  }
}

function mapDispathToProps (dispatch){
  return {
    getLocation: (data) => dispatch(initLocation(data)),
    getAllCategoryInit: (data) => dispatch(initCategories(data)),
    getAllPostInit: (data) => dispatch(initPostAsync(data)),
    getPostSlug: (data) => dispatch(PostSlugAsync(data)),
    getPostNotSlug: (data) => dispatch(PostnotSlugAsync(data)),
    getPostNotSlugbyCountry: (data, excludeCountry) => dispatch(PostnotSlugAsyncbyCountry(data, excludeCountry)),
    getMenuInit: (data) => dispatch(initMenuAsync(data)),
    getCategory: (data) => dispatch(PostCategoryAsync(data)),
    getCategorybyCountry: (data, excludeCountry) => dispatch(PostCategoryCountryAsync(data, excludeCountry)),
    filterBy: (data) => dispatch(filter(data)),
    orderBy: (data) => dispatch(order(data)),
    clearPost: (data) => dispatch(initPostClear(data)),
  }
}

export default connect(mapStateToProps, mapDispathToProps)(Detailpost)



// WEBPACK FOOTER //
// ./src/Detailpost.js